var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tile-grid-split-tile"},_vm._l((_vm.splitTile.imageTiles),function(imageTile,idx){return _c(_setup.TileGridWidgetImageTile,{key:idx,staticClass:"tile-grid-split-tile__image-tile",attrs:{"tile":imageTile,"promo-attrs":_vm.promoAttrs[idx]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }